module.exports = __webpack_public_path__ + "img/D202305_3.06048e84.jpg";